import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { func, string } from "prop-types";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";

const DepositAction = ({ handleClick, className, labelKey, to }) => {
    const handleClickAction = () => {
        if (handleClick) {
            handleClick();
        }
    };

    return (
        (to && (
            <Link className={className || classNames("btn")} to={to}>
                <I18n id={labelKey} />
            </Link>
        )) || <Button className={className} label={labelKey} onClick={handleClickAction} bsStyle="link" />
    );
};

DepositAction.propTypes = {
    handleClick: func.isRequired,
    className: string,
    labelKey: string,
    to: string,
};

DepositAction.defaultProps = {
    className: null,
    labelKey: null,
    to: null,
};

export default DepositAction;
